export const PopularSearches = () => (
<div className="seo-index bg-gradient-to-br from-gray-900/60 to-black/60 p-8 rounded-2xl border-2 border-yellow-400/30">
              <h3 className="text-2xl md:text-3xl font-bold text-yellow-400 mb-6 text-center">
                Recherches Populaires Guadeloupe 2025
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 text-sm text-gray-300">
                <p>✓ Marabout africain retour affectif rapide</p>
                <p>✓ Sorcier vaudou haïtien puissant</p>
                <p>✓ Retour affectif immédiat Guadeloupe</p>
                <p>✓ Marabout sérieux retour ex rapide</p>
                <p>✓ Voyant médium africain sérieux</p>
                <p>✓ Rituel amour puissant efficace</p>
                <p>✓ Désenvoûtement rapide Guadeloupe</p>
                <p>✓ Magie blanche retour amour</p>
                <p>✓ Grand marabout traditionaliste</p>
                <p>✓ Récupérer son ex rapidement</p>
                <p>✓ Voyance sérieuse par téléphone</p>
                <p>✓ Marabout africain consultation</p>
                <p>✓ Sorcellerie vaudou traditionnelle</p>
                <p>✓ Retour de l'être aimé garanti</p>
                <p>✓ Marabout puissant résultats rapides</p>
                <p>✓ Rituel vaudou efficace</p>
                <p>✓ Protection spirituelle puissante</p>
                <p>✓ Guérisseur spirituel africain</p>
                <p>✓ Marabout déplacement domicile</p>
                <p>✓ Consultation voyance urgente</p>
                <p>✓ Rituel retour affectif 3 à 7 jours</p>
                <p>✓ Marabout africain WhatsApp</p>
                <p>✓ Sorcier vaudou consultation</p>
                <p>✓ Voyant médium consultation</p>
              </div>
            </div>
);
